import { createSelector } from '@ngrx/store';
import {  selectNavigationState } from './state';



export const selectNavTabs = createSelector(selectNavigationState, x => x.tabs);


export const selectNavMenues = createSelector(selectNavigationState, x => x.naventries);
